export const GET_ADMINS = 'GET_ADMINS'
export const GET_ADMINS_SUCCESS = 'GET_ADMINS_SUCCESS'
export const GET_ADMINS_FAILED = 'GET_ADMINS_FAILED'

export const SEND_ADMIN_INVITATION = 'SEND_ADMIN_INVITATION'
export const SEND_ADMIN_INVITATION_FAILED = 'SEND_ADMIN_INVITATION_FAILED'
